import React from "react";
import { Box, Card, CardContent, Grid, Skeleton } from "@mui/material";

const AdmissionsCardSkeleton = ({ count = 3 }) => {
  return (
    <Box sx={{ mt: 2 }}>
      <Skeleton variant="text" width={200} height={28} sx={{ mb: 2 }} />
      <Grid container spacing={2}>
        {Array.from({ length: count }).map((_, idx) => (
          <Grid item xs={12} key={idx}>
            <Card variant="outlined">
              <CardContent>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Skeleton variant="circular" width={24} height={24} />
                    <Box>
                      <Skeleton variant="text" width={140} height={24} />
                      <Skeleton variant="text" width={220} height={18} />
                      <Skeleton variant="text" width={160} height={18} />
                      <Skeleton variant="text" width={120} height={18} />
                    </Box>
                  </Box>
                  <Skeleton variant="rounded" width={70} height={24} />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default AdmissionsCardSkeleton;
